import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const DumbellIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 13" {...props}>
      <path
        d="M7.44824 8.48438H15.8251V4.3557H7.44824V8.48438Z"
        fill={colors.primary}
      />
      <path
        d="M22.0558 9.60742H21.4746V3.51902H22.0558C22.7274 3.51985 23.2718 4.06406 23.2724 4.73591V8.39095C23.2716 9.06259 22.7272 9.6068 22.0558 9.60742Z"
        fill={colors.primary}
      />
      <path
        d="M19.1957 12.1816H16.8877V0.65822H19.1957C19.8673 0.65905 20.4118 1.20326 20.4124 1.8749V10.965C20.4118 11.6366 19.8673 12.1808 19.1957 12.1816Z"
        fill={colors.primary}
      />
      <path
        d="M2.86035 10.965V1.8749C2.86097 1.20326 3.40539 0.658843 4.07704 0.65822H6.38504V12.1816H4.07704C3.40539 12.1808 2.86097 11.6366 2.86035 10.965Z"
        fill={colors.primary}
      />
      <path
        d="M0 8.39074V4.73591C0.000622666 4.06406 0.545038 3.51985 1.21668 3.51902H1.79784V9.60742H1.21668C0.545038 9.6068 0.000830218 9.06238 0 8.39074Z"
        fill={colors.primary}
      />
    </SvgIcon>
  );
};

export default DumbellIcon;
